import { useState } from "react";
import { Btn, Toggle } from "@/components/account/Shell";

export const PRINTS_ON = "13thav prints, packs and ships this under your brand. You keep 20% of the standard price plus your markup.";
export const PRINTS_OFF = "You print and fulfill this yourself. You set the price and keep the full sale.";

/** 6.1 / 8.5 — one switch per product: 13thav prints (on) or You print (off). The explanation is always visible. */
export function FulfillmentSwitch({ on, onChange, disabled, testid, text = true }) {
    return (
        <div className="flex min-w-0 flex-col gap-0.5" data-testid={`${testid}-wrap`}>
            <Toggle on={on} onChange={onChange} disabled={disabled} testid={testid} labelOn="13thav prints" labelOff="You print" />
            {text && <p className="text-[10px] leading-tight text-[#4a4a4a]" data-testid={`${testid}-text`}>{on ? PRINTS_ON : PRINTS_OFF}</p>}
        </div>
    );
}

/** 8.5 — the bulk switch at the top of Products with its confirm sheet. */
export function BulkFulfillment({ count, allOn, onApply, disabled, rate = 0.2 }) {
    const [ask, setAsk] = useState(null);
    const pct = Math.round(rate * 100);
    const apply = async () => { await onApply(ask); setAsk(null); };
    return (
        <div className="border border-[#1a1a1a] bg-white px-3 py-2" data-testid="bulk-fulfillment">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                <p className="text-[13px] font-semibold text-[#1a1a1a]">All products: 13thav prints</p>
                <Toggle on={allOn} disabled={disabled} testid="bulk-fulfillment-switch" labelOn="all on" labelOff="all off"
                    onChange={(v) => setAsk(v ? "consignment" : "self")} />
                <p className="text-[12px] text-[#4a4a4a]">{allOn ? PRINTS_ON : "Flip every product at once, or set each row on its own below."}</p>
            </div>
            {ask && (
                <div className="mt-2 border-t border-[#d0d0d0] pt-2" data-testid="bulk-fulfillment-confirm">
                    <p className="text-[13px] text-[#1a1a1a]">
                        {ask === "consignment"
                            ? `Turn 13thav printing on for all ${count} products? You keep ${pct}% of the standard price plus your markup.`
                            : `Turn 13thav printing off for all ${count} products? You print and fulfill every one yourself, set the price and keep the full sale.`}
                    </p>
                    <div className="mt-2 flex gap-2">
                        <Btn tone="solid" onClick={apply} disabled={disabled} testid="bulk-fulfillment-yes">Yes, switch all {count}</Btn>
                        <Btn onClick={() => setAsk(null)} disabled={disabled} testid="bulk-fulfillment-no">Cancel</Btn>
                    </div>
                </div>
            )}
        </div>
    );
}
